import React, { createContext, useContext, useState } from 'react';

const MyVarContext = createContext();

export const MyVarProvider = ({ children }) => {
    const [myVar, setMyVar] = useState('');

    return (
        <MyVarContext.Provider value={{ myVar, setMyVar }}>
            {children}
        </MyVarContext.Provider>
    );
};

export const useMyVar = () => {
    return useContext(MyVarContext);
};